import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import toast from 'react-hot-toast';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import FormButton from 'components/form-components/FormButton';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import { CallAPI } from 'actions/General';
import { isRTL } from 'config/config';

const InternalDashboardActions = ({ ids, isActionButton, actionsCallBack }) => {
  const { t } = useTranslation();

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showDuplicateConfirm, setShowDuplicateConfirm] = useState(false);
  const [displayedMenu, setDisplayedMenu] = useState([]);

  const deleteDashboard = async () => {
    const result = await CallAPI('DELETE_DASHBOARD', null, ids[0].id);
    if (result?.status) {
      toast.success(t('alert_success_dashboard_deleted'));
      actionsCallBack('refresh');
    } else {
      toast.error(result.error);
    }
    setShowDeleteConfirm(false);
  };
  const duplicateDashboard = async () => {
    const result = await CallAPI('DUPLICATE_DASHBOARD', null, ids[0].id);
    if (result?.status) {
      toast.success(t('alert_success_dashboard_duplicated'));
      actionsCallBack('refresh');
    } else {
      toast.error(result.error);
    }
    setShowDuplicateConfirm(false);
  };

  useEffect(() => {
    const actionsList = [
      {
        name: 'action_edit_dashboard',
        permission: true,
        action: () => actionsCallBack('edit', { id: ids[0].id }),
      },
      { name: 'action_duplicate', permission: true, action: () => setShowDuplicateConfirm(true) },
      { name: 'action_delete', permission: true, action: () => setShowDeleteConfirm(true) },
    ];

    let actionListUpdated = actionsList.filter((item) => item.permission === true);
    setDisplayedMenu(actionListUpdated);
  }, [ids]);

  return (
    <div className='dropdown-actions'>
      <DropdownButton
        disabled={ids.length > 0 ? false : true}
        as={ButtonGroup}
        drop='bottom'
        align={isRTL() ? 'end' : 'start'}
        variant='secondary'
        title={
          <>
            {isActionButton ? (
              <img src={dotsIcon} alt='Loading...' />
            ) : (
              <FormButton text='button_action' variant='green-1' icon={dropdownIcon} />
            )}
          </>
        }
      >
        {displayedMenu.map((button, index) =>
          button.name ? (
            <div key={index}>
              <Dropdown.Item
                onClick={button.action}
                key={index}
                className='items theme-size-1 theme-text-grey-1 px-3 py-2 cursor-pointer'
              >
                {t(button.name)}
              </Dropdown.Item>
            </div>
          ) : (
            <Dropdown.Divider key={index} />
          ),
        )}
      </DropdownButton>

      {showDeleteConfirm && (
        <ConfirmationModal
          show={showDeleteConfirm}
          title={t('alert_dashboard_deletion_title')}
          message={t('alert_dashboard_deletion_message')}
          actionList={[
            {
              color: 'black-1',
              text: t('button_cancel'),
              onClick: () => setShowDeleteConfirm(false),
            },
            { color: 'red-1', text: t('button_delete'), onClick: () => deleteDashboard() },
          ]}
        />
      )}
      {showDuplicateConfirm && (
        <ConfirmationModal
          show={showDuplicateConfirm}
          title={t('alert_dashboard_duplication_title')}
          message={t('alert_dashboard_duplication_message')}
          actionList={[
            {
              color: 'black-1',
              text: t('button_cancel'),
              onClick: () => setShowDuplicateConfirm(false),
            },
            { color: 'red-1', text: t('button_duplicate'), onClick: () => duplicateDashboard() },
          ]}
        />
      )}
    </div>
  );
};
InternalDashboardActions.propTypes = {
  actionData: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
  ids: PropTypes.array.isRequired,
  isActionButton: PropTypes.bool.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
};
export default InternalDashboardActions;
